import React, { Component } from 'react';

import ErrorPage from 'styled/components/ErrorPage';
import PageHero from 'components/PageHero';
import ModuleSwitch from 'components/ModuleSwitch';
import { PageMeta as Meta } from 'components/Meta';

import { Topic, ErrorPage as IErrorPage } from 'types';

interface Props {
  errorPage: IErrorPage;
  page: Topic | null;
}

class TopicPageView extends Component<Props> {
  render() {
    const { errorPage, page } = this.props;

    if (!page) return <ErrorPage errorPage={errorPage} />;

    return (
      <div className="relative">
        <Meta
          title={page.hero.title}
          description={page.hero.description}
          image={page.hero.desktopImage.src}
          seo={page.seo}
        />
        <PageHero hero={page.hero} withoutAnimation />
        <div className="relative z-2">
          <ModuleSwitch modules={page.modules} />
        </div>
      </div>
    );
  }
}

export default TopicPageView;
